<template>
  <VView class="top" back-button-to="/menu" header="Top 200 graczy">
    <div class="top__players">
      <div class="top__player" v-for="(player, index) in players" :key="index">
        <VText>{{ index + 1 }}.</VText>
        <VText>{{ player.name }}</VText>
      </div>
    </div>
  </VView>
</template>

<script>
export default {
  name: 'Top',

  data: () => ({
    players: [],
  }),

  async mounted() {
    const { data: players } = await this.$bricodes.getPublicEntries();

    const playersBestScores = players
      .filter(player => !player.isFavorite && player.isConfirmed && player.result.score !== undefined)
      .reduce((acc, player) => {
        const playerName = `${player.firstName}`.trim().toLowerCase();
        const playerScore = player.result.score;

        if (!acc[playerName] || acc[playerName].score < playerScore) {
          acc[playerName] = { name: playerName, score: playerScore };
        }

        return acc;
      }, {});

    const mappedScores = players.map(player => ({
      name: `${player.firstName}`.trim().toLowerCase(),
      score: player.result.score,
    }));

    this.players = Object.values(mappedScores)
      .sort((a, b) => b.score - a.score)
      .slice(0, 200);
  },
};
</script>

<style lang="scss" scoped>
.top {
  &__players {
    max-width: 744px;
    margin: 0 auto;
  }

  &__player {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 20px 12px;

    &:nth-child(odd) {
      background-color: #1a1109;
    }

    &:nth-child(even) {
      background-color: #2f1e10;
    }

    &:not(:first-child) {
      margin-top: 5px;
    }

    &:first-child {
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
    }

    &:last-child {
      border-bottom-left-radius: 10px;
      border-bottom-right-radius: 10px;
    }

    ::v-deep .text {
      color: #ffffff;

      &:not(:first-child) {
        margin-top: 0;
      }
    }
  }
}
</style>

